import { Box } from '@mui/material';

import cofundedEuLogoUrl from '../../assets/images/cofunded_EU_logo.png';

export const LicenseInformation = () => {
  return (
    <Box sx={{ marginBottom: 2 }}>
      <Box
        alt={'EU logo'}
        component={'img'}
        src={cofundedEuLogoUrl}
        sx={{ height: '75px', marginRight: '10px' }}
      />
    </Box>
  );
};
